import type { PlaygroundNavParams } from '@euler/playground/Index';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';

/**
 * Back from a category page: to the gallery index it was opened from, or,
 * deep-linked straight to the category, to an index put in its place.
 */
export function useBackToGallery(): () => void {
  const navigation = useNavigation<StackNavigationProp<PlaygroundNavParams>>();
  return useCallback(() => {
    const { routes, index } = navigation.getState();
    if (routes[index - 1]?.name === 'BiCharts') navigation.goBack();
    else navigation.replace('BiCharts', {});
  }, [navigation]);
}
